import { createSelector } from '@reduxjs/toolkit';

import type { RootState } from '@/store';

export const selectArbitros = (state: RootState) => state.arbitros.arbitros;
export const selectEspecialidadesArbitrais = (state: RootState) => state.arbitros.especialidades;
export const selectArbitrosLoading = (state: RootState) => state.arbitros.isLoading;
export const selectArbitrosSaving = (state: RootState) => state.arbitros.isSaving;
export const selectArbitrosError = (state: RootState) => state.arbitros.error;

export const selectPesoTotalAlocado = createSelector([selectArbitros], (arbitros) =>
  arbitros
    .filter((arbitro) => arbitro.status === 'ativo')
    .reduce((soma, arbitro) => soma + arbitro.peso, 0),
);
